import { useState, useEffect } from 'react';
import { SendMessage} from './App.js';
import icobackblue from './img/ico-backblue.svg';
import icobackred from './img/ico-backred.svg';
import strings from './strings.js'
import { v4 as uuid } from 'uuid';
import localForage from "localforage";

import { toast } from 'react-toastify';

const API_URL = "https://www.starboxkod.com/api";

const SelectingYesNoYtCard = ({ song, onClick, stateVer, tableNo, lang } ) => {


    const [selectingKey, setSelectingKey] = useState(0);
    const [selectingVocal, setSelectingVocal] = useState(false);
    const [selectingRec, setSelectingRec] = useState(false);
    const [selectingRecUuid, setSelectingRecUuid] = useState("");

    return (

    <div className="LMAOselecting">
        <div className="mui-overlay"
        onClick={(e) => {e.preventDefault(); /* onClick() */}}
        ></div>
        <div className="actions-sheet" onClick={(e) => {e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation();}}>
            <div className="preview">


                <iframe
                    className="previewActual"
                    width="384" 
                    height="216" 
                    src={`https://www.youtube.com/embed/${song.id.videoId}?start=103?autoplay=1`}
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; 
                    autoplay; 
                    clipboard-write; 
                    encrypted-media; 
                    gyroscope; 
                    picture-in-picture; 
                    web-share" allowfullscreen></iframe>
            </div>
            
            <div className= "songcontrols">
                <div className = "songinfo">
                    <div className="actions-sheetSongNum">
                    </div>
                    <div className="actions-sheetName" dangerouslySetInnerHTML={{__html: song.snippet.title.substring(0, 20)}}></div>
                    
                    

                    <div className="actions-sheetSinger">
                        {song.snippet.channelTitle.substring(0, 20)}
                    </div>
                </div>
            </div>



            <div className="add-song-container">
                <a className="add-song-container-Back" onClick={(e) => {e.preventDefault();  onClick()}} >
                <img
                    src={document.body.getAttribute('data-skin') === '1' ? icobackred :icobackblue} 
                    alt="back"
                    
                />
                </a>
                
                <a className="ActionPaneladdsong-btn"
                    onClick={(e) => {e.preventDefault();
                        SendMessage(`[{"type":"TABLE_CLIENT_ADD_YT", "tableId":"t${tableNo}", "userId":"${JSON.parse(localStorage.getItem("sn"))}", "videoId":"${song.id.videoId}", "ytname":"${song.snippet.title}"}]`);
                        onClick();

                        toast.success(lang?strings.cn.addSongSuccess:strings.en.addSongSuccess, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                            icon: false,
                            });

                    }}
                >
                    {lang ? strings.cn.addSong : strings.en.addSong}
                </a>
            </div>

        </div>
        </div>
        

    );
}

export default SelectingYesNoYtCard;